export default function withRegionCookie() {
    return async (ctx) => {
        const { cookies } = ctx;

        // Check if Origin_Session cookie exists
        if (!cookies.Origin_Session) {
            const region = process.env.AWS_REGION === 'us-west-2' ? 'WEST' : 'EAST';
            cookies.set('Origin_Session', region, { path: '/' });
        }
    };
}
